import { useMemo } from "react";
import { getTsTmcProviderRestrictionPolicy } from "@/config/feature-flags/tsTmcProviderRestriction";
import { useAdditionalInfo } from "@/stores/domains/additionalInfo";

export const useTsTmcProviderRestrictionPolicy = () => {
  const locationId = useAdditionalInfo((state) => state.location?.value ?? null);
  const roleLabel = useAdditionalInfo((state) => state.role?.label ?? null);

  return useMemo(() => {
    return getTsTmcProviderRestrictionPolicy({ locationId, roleLabel });
  }, [locationId, roleLabel]);
};

export const useTsTmcProviderRestriction = (): boolean => {
  const policy = useTsTmcProviderRestrictionPolicy();
  return policy.enabled;
};
